<template>
  <v-container>
    <!-- xs="3" sm="5" md="5" lg="5" xl="5" -->
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <form autocomplete="off">
        <v-row dense>
          <v-col>
            <mb-input-text v-model="user.name" name="reg_name" label="Nome Completo"
              rules="required" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 3">
            <mb-date
              v-model="user.birthdate"
              name="reg_birthdate"
              label="Data de Nascimento"
              rules="required"
            />
          </v-col>
          <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 3">
            <mb-select
              v-model="user.genre"
              :items="sexItems"
              itemText="text"
              itemValue="vl"
              name="reg_sex"
              label="Sexo"
              rules="required"
            />
          </v-col>
          <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 3">
            <mb-input-phone
              v-model="user.phones.mobile"
              name="reg_phone"
              label="Celular"
              rules="required"
            />
          </v-col>
          <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 3">
            <mb-input-cpf
              v-model="user.cpf"
              name="cpf"
              label="CPF"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <mb-input-text
              v-model="user.email"
              name="reg_email"
              label="Email"
              rules="required|email"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 4">
            <mb-input-password
              v-model="user.password"
              name="reg_password"
              label="Senha"
              rules="required"
            />
            <!-- |confirmed:passwordConfirm -->
          </v-col>
          <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 4">
            <mb-input-password
              v-model="passwordConfirm"
              name="reg_passwordConfirm"
              label="Confirmação da Senha"
              rules="required|password:reg_password"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-switch id="reg_terms" v-model="termsAcceptance">
              <template v-slot:label>
                <div>
                  Aceito os
                  <a
                    target="_blank"
                    :href="`${pathPgsMb}/app/terms/term`"
                    @click.stop
                  >Termos de Uso</a>
                  e a
                  <a
                    target="_blank"
                    :href="`${pathPgsMb}/app/terms/policy`"
                    @click.stop
                  >Política de Privacidade</a>
                </div>
              </template>
            </v-switch>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col align="right">
            <mb-text-button name="reg_register" label="Criar Conta"
              :disabled="!termsAcceptance"
              :loading="registerBtnLoading"
              @click="register"
            />
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbInputText from '@/components/general/inputs/MbInputText';
import MbInputPhone from '@/components/general/inputs/MbInputPhone';
import MbInputPassword from '@/components/general/inputs/MbInputPassword';
import MbSelect from '@/components/general/inputs/MbSelect';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import MbDate from '@/components/general/inputs/MbDate';
import MbInputCpf from '@/components/general/inputs/MbInputCpf';

export default {
  data: () => ({
    user: {
      name: null,
      birthdate: null,
      genre: null,
      phones: {
        mobile: null,
      },
      email: null,
      password: null,
    },
    sexItems: [
      { vl: 'female', text: 'Feminino' },
      { vl: 'male', text: 'Masculino' },
    ],
    passwordConfirm: null,
    termsAcceptance: false,
    registerBtnLoading: false,
  }),
  computed: {
    pathPgsMb() {
      return process.env.VUE_APP_PATH_PGS_MB;
    },
  },
  methods: {
    async register() {
      const self = this;
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.registerBtnLoading = true;
        this.$store
          .dispatch('patientUser/register', this.user)
          .then(() => {
            bus.$emit('message', {
              message: 'Usuário criado com sucesso!',
              type: 'success',
            });

            self.$emit('registered');
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.registerBtnLoading = false;
          });
      }
    },
  },
  components: {
    ValidationObserver,
    MbInputText,
    MbInputPhone,
    MbInputPassword,
    MbSelect,
    MbTextButton,
    MbDate,
    MbInputCpf,
  },
};
</script>
